import { forwardRef } from 'react';
import { SkeletonLoader } from 'components/SkeletonLoader/SkeletonLoader';

import './QuoteRowSkeleton.scss';

export const QuoteRowSkeleton = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div className="quoteRowSkeleton" ref={ref} {...props}>
      <div className="quoteRowSkeletonCell">
        <SkeletonLoader width="100%" height="1.5rem" />
        <SkeletonLoader width="60%" height="1.5rem" />
      </div>
      <div className="quoteRowSkeletonCell">
        <SkeletonLoader width="100%" height="1.5rem" />
        <SkeletonLoader width="60%" height="1.5rem" />
      </div>
      <div className="quoteRowSkeletonCell">
        <SkeletonLoader width="100%" height="1.5rem" />
        <SkeletonLoader width="60%" height="1.5rem" />
      </div>
      <div className="quoteRowSkeletonCell">
        <SkeletonLoader width="100%" height="1.5rem" />
        <SkeletonLoader width="60%" height="1.5rem" />
      </div>
      <div className="quoteRowSkeletonCell">
        <SkeletonLoader width="100%" height="1.5rem" />
        <SkeletonLoader width="60%" height="1.5rem" />
      </div>
      <div className="quoteRowSkeletonCell">
        <SkeletonLoader width="100%" height="1.5rem" />
        <SkeletonLoader width="60%" height="1.5rem" />
      </div>
    </div>
  );
});

QuoteRowSkeleton.displayName = 'QuoteRowSkeleton';
